import _memoize from 'lodash/memoize';
import { makeThemeColor, TERTIARY } from '@tornado-rdk/theme';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../../../../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const KEYBOARD_HEIGHT = {
  [HD]: 81,
  [FULL_HD]: 113,
};

export const KEYBOARD_WIDTH = {
  [HD]: 244,
  [FULL_HD]: 364,
};

export const colors = {
  background: makeThemeColor(TERTIARY),
};

export const ICON_SIZE = {
  [HD]: 24,
  [FULL_HD]: 36,
};

export const { screenSize, colorMode } = defaultContext;

export const getBasicIconViewBox = _memoize(screenSize => ({
  h: ICON_SIZE[screenSize],
  w: ICON_SIZE[screenSize],
}));

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;

  return {
    h: KEYBOARD_HEIGHT[screenSize],
    w: KEYBOARD_WIDTH[screenSize],
    Background: {
      rect: true,
      h: KEYBOARD_HEIGHT[screenSize],
      w: KEYBOARD_WIDTH[screenSize],
      color: colors.background[colorMode],
    },
  };
};
